import type { PricingContent } from "../types";
import { PT_BR_FAQS } from "./home";

export const PT_BR_PRICING: PricingContent = {
  seoTitle: "Preços do Crayo | Planos para cada criador",
  seoDescription:
    "Preços simples e transparentes para vídeos curtos com IA. Créditos de workflow, vozes com IA, imagens, armazenamento e View Tracker em todos os planos.",
  name: "Preços do Crayo",
  crumb: "Preços",
  h1: "Preços",
  subheading: "Todos os planos incluem todas as ferramentas do Crayo. Escolha o quanto você cria.",
  faqs: [
    ...PT_BR_FAQS,
    {
      question: "Como o Crayo se compara com Opus Clip, CapCut e Submagic?",
      answer:
        "O Crayo cobra um crédito de workflow por vídeo finalizado e inclui todas as ferramentas em todos os planos. O Opus Clip cobra por minuto de vídeo fonte enviado, o CapCut não tem página pública de preços e o Submagic limita créditos, quantidade de vídeos e minutos por vídeo ao mesmo tempo. A central de comparações mostra preços e recursos com data e fonte para cada um.",
      link: { href: "/compare", label: "Ver todas as comparações" },
    },
  ],
};
